import { isNavigationFailure } from 'vue-router';
import router from './index';
export function internalLocation(url) {
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) {
        return null;
    }
    const base = router.options.base || '/';
    const prefix = base.replace(/\/$/, '');
    if (prefix && url.pathname !== prefix && !url.pathname.startsWith(`${prefix}/`)) {
        return null;
    }
    const path = url.pathname.slice(prefix.length) || '/';
    const record = router.getRoutes().find(candidate => candidate.path !== '*' && candidate.regex.test(path));
    if (!record || record.meta.documentNavigation) {
        return null;
    }
    return `${path}${url.search}${url.hash}`;
}
export function navigateWindow(route, replace = false) {
    const url = new URL(route, window.location.origin);
    const location = internalLocation(url);
    if (location === null) {
        if (replace) {
            window.location.replace(url.href);
        }
        else {
            window.location.assign(url.href);
        }
        return true;
    }
    if (router.currentRoute.matched.length &&
        router.resolve(location).route.fullPath === router.currentRoute.fullPath) {
        return false;
    }
    const method = replace ? 'replace' : 'push';
    router[method](location, () => { }, error => {
        if (!isNavigationFailure(error)) {
            console.error('Navigation failed:', error);
        }
    });
    return true;
}
export function handleInternalLink(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey ||
        event.ctrlKey || event.shiftKey || event.altKey) {
        return;
    }
    const target = event.target;
    const element = target instanceof Element ? target : target?.parentElement;
    const anchor = element?.closest('a[href]');
    if (!anchor || anchor.hasAttribute('download') ||
        (anchor.target && anchor.target.toLowerCase() !== '_self') ||
        anchor.hasAttribute('data-document-navigation') ||
        anchor.hasAttribute('data-toggle') || anchor.hasAttribute('data-bs-toggle') ||
        anchor.classList.contains('showAlcoholModal') ||
        /\bexternal\b/i.test(anchor.rel)) {
        return;
    }
    const href = anchor.getAttribute('href');
    if (!href || href.trim().startsWith('#')) {
        return;
    }
    const url = new URL(anchor.href);
    if (url.pathname === window.location.pathname &&
        url.search === window.location.search && url.hash) {
        return;
    }
    if (internalLocation(url) === null) {
        return;
    }
    event.preventDefault();
    navigateWindow(url.href);
}
